import {
  MEDICAL_PLAN_ERROR,
  DENTAL_PLAN_ERROR,
  HIRE_DATE_ERROR,
  ELIGIBLE_PAY_EMPTY_ERROR,
  ELIGIBLE_PAY_NUMERIC_ERROR,
  DENTAL_COVERAGE_ERROR,
  MEDICAL_PLAN_COVERAGE_ERROR,
  PRIMARY_RETIREMENT_ERROR,
  DESIGNATED_FACULTY_ERROR
} from './constants/errorDisplay.js';

import RESULTS_LINKS from './constants/resultsLinks.js';

import {
  OPT_OUT_OF_DENTAL,
  OPT_OUT_OF_MEDICAL,
  ON_OR_AFTER_JULY_1_2016,
  PENSION_CHOICE,
  YES
} from './constants/menuOptions.js';

export const validateForm = formData => {
  const {
    med_plan,
    med_cov,
    dental_plan,
    dental_cov,
    hired_date_tier,
    pension_choice,
    pension_choice_elig,
    disabled_med_Plan,
    disabled_den_Plan,
    salary,
    hiredBeforeDate
  } = formData;


  const errors = [];

  //Error Medical plan selector is empty
  if (!med_plan) {
    errors.push(MEDICAL_PLAN_ERROR);
  }

  //Error Medical coverage selector is empty when medical plan is selected
  if (med_plan && (med_plan !== OPT_OUT_OF_MEDICAL) && !med_cov && !disabled_med_Plan) {
    errors.push(MEDICAL_PLAN_COVERAGE_ERROR);
  }

  //Error Dental plan selector is empty
  if (!dental_plan) {
    errors.push(DENTAL_PLAN_ERROR);
  }

  //Error Dental coverage selector is empty when dental plan is selected
  if (dental_plan && (dental_plan !== OPT_OUT_OF_DENTAL) && !dental_cov && !disabled_den_Plan) {
    errors.push(DENTAL_COVERAGE_ERROR);
  }

  //Error Hire Date Tier selector is empty
  if (!hired_date_tier) {
    errors.push(HIRE_DATE_ERROR);
  }

  //Error primary retirement is empty when tier is selected
  if ((hired_date_tier === ON_OR_AFTER_JULY_1_2016) && !pension_choice)  {
    errors.push(PRIMARY_RETIREMENT_ERROR);
  }

  //Error pension choice eligibility is empty when pension choice is selected and hired after 7/1/2016
  if ((pension_choice === PENSION_CHOICE) && (hiredBeforeDate !== YES) &&!pension_choice_elig) {
    errors.push(DESIGNATED_FACULTY_ERROR);
  }

  //Error Pay Input is empty
  if (!salary.trim()) {
    errors.push(ELIGIBLE_PAY_EMPTY_ERROR);
  } else {
    const salaryString = removeMoneySymbols(salary.trim());
    const numbersOnly = removeDecimalPoint(salaryString);

    if (hasNonNonNumericSymbols(numbersOnly) || isNaN(parseFloat(salaryString))) {
      errors.push(ELIGIBLE_PAY_NUMERIC_ERROR);
    }
  }

  return errors;
};


export const removeMoneySymbols = string => {
  return string.replace(/\$|,/g, '');
}

const hasNonNonNumericSymbols = string => {
  return string.match(/\D/g, '');
}

const removeDecimalPoint = string => {
  return string.replace(/\./g, '');
}

export const formatNumberAsUSD = (value, roundUp = false) => {
  //value = roundUp ? Math.ceil(value) : Math.round(value);
  return value.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD'
  });
};

export const formatResultsObject = resultsObject =>
  RESULTS_LINKS.map(result => {
    const costs = resultsObject[result.key];
    const { UC, employee } = costs;

    return {
      ...result,
      UC: formatNumberAsUSD(UC),
      employee: formatNumberAsUSD(employee),
    };
  });

export const getTotals = results => {
  const totalCosts = Object.keys(results).reduce((totals, key) => {
    const result = results[key];
    totals.UC += result.UC;
    totals.employee += result.employee;

    return totals;
  }, {
    UC: 0,
    employee: 0
  });

  return totalCosts;
};
